
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`เครื่องมือนี้ช่วยให้คุณแก้ไขรายการส่วนผสมได้ คุณสามารถเพิ่ม ลบ หรือแก้ไขรายการส่วนผสม

                <br>
                อักขระนี้ <span class="highlight">␣</span> แทนช่องว่าง
                <br>
                อักขระนี้ <span class="highlight">↩︎</span> แทนการแบ่งบรรทัด `,
'hb28f1f2ec1744ee9': html`คุณสมบัติเหล่านี้ถูกสร้างและจัดเก็บโดยผู้ใช้เพื่อการใช้งานทุกประเภท คุณสามารถเพิ่มคุณสมบัติของคุณเองได้อย่างอิสระ
                    คุณสมบัติและค่าที่คุณสร้าง
                    <strong>จะต้องเป็นข้อมูลจริง</strong>คุณสามารถเจาะลึก
                    <a href="${0}">รายการคุณสมบัติที่ชุมชน</a>
                    ใช้อยู่แล้ว หรือสำรวจเอกสารประกอบของคุณสมบัติ
                    <a href="${1}">และเครื่องมือค้นหา</a>`,
's000a5b76bd3a01c2': `กำลังโหลดคุณสมบัติ...`,
's000d98595e959c1e': `ดาวน์โหลดที่ Google Play`,
's013bdc8cf0d3583d': `ช่วยเราเรื่องส่วนผสม`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `ตรวจสอบพืชผล`,
's03e9c8114521b998': `ฉันจะแก้ไขส่วนผสม`,
's05ec315d9308091a': `ไอคอนมุมบาร์โค้ด`,
's061eb5af92512c85': `ช่วยอีกเรื่องได้ไหมค่ะ?`,
's06847c221c4c0bc1': `ฉันต้องการสร้างคุณสมบัติเพื่อ [อธิบายกรณีการใช้งานของคุณ]...`,
's06f6c6f99db6b552': `ต้นฉบับ`,
's081e2ad82db71e1d': `ค่าที่จัดกลุ่ม`,
's09205907b5b56cda': `ไม่ใช่`,
's0b4235aae602a950': `เอกสารเฉพาะ`,
's0bb2d48532acc455': `ดาวน์โหลด CSV`,
's0d5b7fee0311db68': `คุณสมบัติ`,
's0fb218abc2e157ed': `ทำให้ภาพไม่ถูกต้อง`,
's100c4928cc74642a': `สนับสนุนการพัฒนาการวิจัยด้านสาธารณสุข`,
's10db5498186c083b': `ยกเลิกการเพาะปลูก`,
's11a18a69b30b65ed': `ช่วยเราแก้ไขข้อผิดพลาดในรายการส่วนผสม`,
's1205d5f6fccf8e69': `มูลค่าทรัพย์สิน`,
's15d64a0a6715285a': `กุญแจใหม่`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `พื้นที่การเลือก`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `ช่วยเราแก้ไขข้อมูลโภชนาการ`,
's1e00019dc454872d': `กรุณาระบุชื่อทรัพย์สินโดยใช้แอตทริบิวต์ property-name`,
's1e49126af0935a5b': `รายการผลิตภัณฑ์ที่ใช้คุณสมบัตินี้`,
's21e73088de6f26f3': `ดาวน์โหลดที่ Google Play`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `ยกเลิก`,
's2db7b654c0a9bde0': `บันทึกทรัพย์สิน`,
's300b3a6ee4e1252d': str`การจับคู่ที่แย่ ${0}%`,
's33f786bb6b4f0cf4': `ผลของพืชผล`,
's33f85f24c0f5f008': `บันทึก`,
's34be4af4e8fec4ae': `ถามชุมชนก่อน`,
's36d86adc823cbfa6': `ก่อนที่จะสร้างทรัพย์สินใหม่ ควรหารือกับชุมชนก่อน:`,
's3781d25aa51a736c': `เอกสารประกอบของ Folksonomy Engine`,
's383ae4449428b61e': `รีเซ็ตการครอบตัด`,
's39bcf88721a1e8ee': `รีเซ็ตการเลือก`,
's39e14e14300694c7': `เอกสารและแนวทางปฏิบัติ`,
's3b430cfa5c1fe7f4': str`เอกสารสำหรับ ${0}`,
's3f4e4b52f230a892': `ผ้าใบภาพ`,
's417b90913e05bc17': `ตัวอย่าง`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `ภาพกลาง`,
's42dd66b2441566fd': `ไอคอนตรงกลาง`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `เพิ่มสารอาหารอื่นๆ`,
's453ab0dbb9b5c777': `ปรับขนาดให้เหมาะสม`,
's475b08749d0706ed': `ช่วยเราให้ข้อมูลแก่ผู้บริโภคนับล้านทั่วโลกเกี่ยวกับสิ่งที่พวกเขากิน`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `จำนวนผลิตภัณฑ์`,
's4df2f533c0c1e7d0': `การควบคุมภาพ`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `การเลือกย้าย`,
's4f751fb9b3ed766c': `การสร้างคุณสมบัติใหม่`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `กรอกชื่อทรัพย์สิน...`,
's55d7249883a98ca1': `เกี่ยวกับทรัพย์สินนี้บน Open Food Facts wiki`,
's565867d84c04aea2': `คุณสมบัติการกรอง...`,
's5666afe5cd0166de': `กรุณาแก้ไขข้อผิดพลาดหรือแก้ไขข้อความก่อนยืนยัน`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `กำลังโหลดสินค้า...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `ช่วยเราแก้ไขข้อมูลโภชนาการ`,
's5dd6f12783fca34f': `แก้ไขรายการส่วนผสม`,
's5e8250fb85d64c23': `ปิด`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `ฉันสนับสนุน`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `แก้ไข`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `ขอบคุณสำหรับการสนับสนุนของคุณ!`,
's6cee7cad81dfedd1': `ภาพครอบตัด`,
's6d7b6cdedaadfb6e': `ทุกการบริจาคมีความสำคัญ! เราขอขอบคุณสำหรับการสนับสนุนของคุณในการสร้างความโปร่งใสในด้านอาหารให้มากยิ่งขึ้นในโลก`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`แมตช์ที่ดี ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `เอกสารประกอบ`,
's787dd11bed0dc88a': `ปรับขนาดด้านซ้าย`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `เรียนรู้เพิ่มเติมเกี่ยวกับการสร้างทรัพย์สินและแนวทางปฏิบัติ:`,
's8038273de2cf8b73': `กรุณาเลือกภูมิภาคที่จะครอบตัด`,
's839cc2908a5387f2': `กรองบาร์โค้ด...`,
's86197dcf3e96af64': `เรียกดูและค้นหาคุณสมบัติที่มีอยู่`,
's8a63be30a129a59c': `ปรับขนาดด้านล่าง`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `ปรับขนาดด้านบนขวา`,
's8db84aa4bc949af2': `บันทึกทรัพย์สินใหม่`,
's8f839a03997a16d7': `ดูสินค้า`,
's901ae1e236ac45d3': `ยกเลิกการลบ`,
's907f7a97c6b29425': `โปรดทราบว่าแบบจำลองข้อมูลอาจถูกปรับเปลี่ยน โปรดใช้ด้วยความเสี่ยงของคุณเอง`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `วัตถุดิบ :`,
's9a7f60fce090ecaf': `ไม่สามารถโหลดคุณสมบัติได้ โปรดลองอีกครั้งในภายหลัง`,
's9b87abd68fb9df45': `ไม่พบ? สร้างคีย์ใหม่ {value}`,
's9c0f52425fd2f07e': `อาจไม่ตรงกัน`,
's9fc41f789c63b40d': `ผลิตภัณฑ์`,
'sa1fa766e0d5634d7': `ไม่มีคะแนน`,
'sa548778b24054030': `สำรวจคุณสมบัติทั้งหมดที่ส่งมาจากโครงการ Folksonomy Engine คุณสมบัติเหล่านี้ให้ข้อมูลเมตาและข้อมูลเชิงลึกเพิ่มเติมเกี่ยวกับผลิตภัณฑ์ในฐานข้อมูล Open Food Facts`,
'sa63907958bd0ec4b': `ปรับขนาดด้านบนซ้าย`,
'sa95b4224f685a36a': `ปิดโมดอล`,
'sab56a1d439576fd6': `ไอคอนข้อเสนอแนะ`,
'sac47ea2901d04c15': `ปรับขนาดด้านล่างซ้าย`,
'sb125227d436c2925': `ค้นหาแนวคิดทรัพย์สินของคุณในฐานข้อมูลทรัพย์สินที่มีอยู่:`,
'sb125568d43642e6f': `ตอบคำถามเกี่ยวกับผลิตภัณฑ์`,
'sb1c538e038f9b214': str`แมตช์ที่ดีมาก ${0}%`,
'sb28639570ff3b852': `รายการทรัพย์สินทั้งหมด`,
'sb3bdd638a58d30f4': `สร้างชุมชนของพลเมืองที่มีความมุ่งมั่น`,
'sb3cbcc1bd0fff140': `เมื่อคุณได้ตรวจสอบแล้วว่าทรัพย์สินของคุณไม่มีอยู่จริงและชุมชนเห็นด้วยว่าทรัพย์สินนั้นมีประโยชน์ คุณต้องบันทึกไว้ในวิกิก่อน`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `ไม่พบผลิตภัณฑ์สำหรับทรัพย์สินนี้`,
'sb7f72e4c8a2d3357': `กรองค่า...`,
'sb8178320160f84ea': `แสดงพืชผล`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `ข้อมูลเชิงลึกทั้งหมดได้รับการตอบแล้ว ขอบคุณสำหรับความช่วยเหลือของคุณ!`,
'sbd9a0b2293b3cd3c': `หน่วยบริโภค`,
'sbe472dc3c2685985': `ค่าที่สอดคล้องกัน`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `ปรับขนาดด้านบน`,
'sc1c08d0cbcc3bd24': `ไม่ตรงกัน`,
'sc52696641af72b53': `ติดตั้งแอปเลย!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `ข้อเสนอแนะการแก้ไข`,
'sc681b137e8f604f7': `ยืนยันการลบ`,
'sc6daf8a31883f8b9': `ย้ายภาพ`,
'sc895972c88d38ca5': `ทรัพย์สินโฟล์คโซโนมี`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `แถว`,
'scb3b0671d7b7f640': `ค่าใหม่`,
'scb489a1a173ac3f0': `ถูกต้อง`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `เข้าร่วมการสนทนาใน Slack`,
'scdb6cad0b92721bf': `ไม่พบคุณสมบัติใดๆ`,
'scf23a05631f93732': `ยืนยันการลบ`,
'scfed2f270ef6a3aa': `เลือกพื้นที่`,
'sd1022bc1ef9204f7': `ภาพที่สามารถซูมได้`,
'sd1077c055cf9ba6b': `ช่วยเราตรวจสอบรายการส่วนผสมของผลิตภัณฑ์`,
'sd698d21ddecba56b': `เฮ้! คุณสามารถช่วยเราปรับปรุงข้อมูลผลิตภัณฑ์ได้โดยตอบคำถามในส่วนต่อไปนี้:`,
'sd82bc2decefa621b': `ยังคงเป็นอิสระจากอุตสาหกรรมอาหาร`,
'sdb97e5976482606e': `ตรวจสอบว่ามีคุณสมบัติอยู่แล้วหรือไม่`,
'sdbf806fefc584115': `คุณควรจะหา`,
'sdc673e73b5c13aea': `ลบ`,
'sdc792b75f1edcaba': `ช่วยเราแก้ไขการสะกดส่วนผสม`,
'sdca5deead576ceee': `ปรับขนาดมุมขวาล่าง`,
'sdcc2555c5dde524f': `คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้? การดำเนินการนี้ไม่สามารถย้อนกลับได้`,
'se206feec7ec57b28': `ต่อ 100 กรัม`,
'se419a9ab36987490': `ทำให้เป็นโมฆะ`,
'se5127cf0f92e7e48': `เคล็ดลับ: คุณยังสามารถค้นหา`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `ฉันจะเสนอวิธีปลูกพืชที่ดีกว่า`,
'seea3800e27baa686': `ผลิตภัณฑ์แต่ละชิ้น`,
'sefaba4adc4ec9219': `โฟล์คโซโนมี พร็อพเพอร์ตี้`,
'seffa8ca49175b5f0': `คุณสมบัติเฉพาะตัว`,
'sf44a6b3b232c28ea': str`แทนที่ค่าปัจจุบันด้วย ${0}`,
'sf4cd86a2f5ef2588': `บาร์โค้ดสินค้า`,
'sf57a61152168cc81': `ช่วยเราแก้ไขการตรวจจับส่วนผสม`,
'sf88b90b8ba23871c': `ไม่ทราบคู่ที่ตรงกัน`,
'sf9aee319a006c9b4': `เพิ่ม`,
'sfacbbe968fa7d773': `ชื่อทรัพย์สิน :`,
'sfc40ea3d5d5aa6f8': `เงินบริจาคของคุณช่วยสนับสนุนการดำเนินงานประจำวันของสมาคมไม่แสวงหาผลกำไรของเรา:`,
'sfe87465d50530725': `ค่าที่สอดคล้องกัน`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  